import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { getSession } from './modules/auth.js'
import store, { history } from './store'
import App from './containers/app'

import 'sanitize.css/sanitize.css'
import './styles/css/index.css'

const target = document.querySelector('#root')

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        <App />
      </div>
    </ConnectedRouter>
  </Provider>,
  target
)

store.dispatch(getSession())


// WEBPACK FOOTER //
// ./src/index.js